import {ToasterType} from "@/types/ToasterConfig";
import store from "@/store";
import {AxiosError} from "axios";

export class ErrorService {


  public static dealWithTheError(error: AxiosError, isVisible: boolean = true, visibleOnNextPage: boolean = false) {
    const response = error.response;
    const details = response?.data;

    const message = (details?.message) ? details.message : "Une erreur s'est produite. Merci de réessayer.";
    const secondMessage = (details?.secondMessage) ? details.secondMessage : [];

    store.commit('updateToaster', {
      type: ToasterType.Red,
      message: message,
      secondMessage: secondMessage,
      isVisible: isVisible,
      visibleOnNextPage: visibleOnNextPage,
    });
  }

}
